/*
 * @Description: Axios 接口配置文件
 * @Author: Pancras
 * @Date: 2019-10-24 14:17:51
 * @LastEditors: Adlj
 * @LastEditTime: 2022-10-13 18:14:30
 */
import store from '@/store'
import router from '@/router'
import axios from 'axios'
import Qs from 'qs'
import { getToken } from '@/libs/auth'
import errorCode from '@/const/errorCode'

// 返回其他状态码(否则自定义 errorCode 不会被捕捉)
axios.defaults.validateStatus = status => {
  return status >= 200 && status <= 500 // 默认的
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 30000, // 请求超时时间
  // 参数序列化
  paramsSerializer: function (params) {
    return Qs.stringify(params, { arrayFormat: 'repeat', allowDots: true, skipNulls: true })
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 判断是否是获取 Token 的请求
    const isToken = (config.headers || {}).isToken === false
    // 如果需要携带 Token
    if (getToken() && !isToken) {
      config.headers.Authorization = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    
    return config
  },
  (error, request) => {
    // Promise 失败
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const status = Number(response.status) || 200
    const message = response.data.msg || errorCode[status] || errorCode.default
    // 当前操作没有权限
    if (status === 401) {
      store.dispatch('LogOut').then(() => {
        router.push({ path: '/login' })
      })
      return
    }

    // 接口请求成功,但是服务器返回自定义错误
    if (status !== 200 || response.data.code === 1) {
      // Promise 失败
      return Promise.reject(new Error(message))
    }
    // 服务端自定义返回码 0:成功 1:失败
    const { code } = response.data

    // 无 Code 为非 Token 请求,可能是登录或验证码等请求
    if (code === undefined) {
      return response
    } else {
      // 接口请求返回服务端数据,而不是 Response
      return response.data
    }
  },

  error => {
    return Promise.reject(error)
  }
)

export default service
